var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenQuote = function SvgOpenQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.75 19.25h3.5a2 2 0 0 0 2-2v-4.286a2 2 0 0 0-2-2h-1.5V4.75s-4 1.554-4 6.214v6.287c0 1.105.895 1.999 2 1.999ZM4.75 19.25h3.5a2 2 0 0 0 2-2v-4.286a2 2 0 0 0-2-2h-1.5V4.75s-4 1.554-4 6.214v6.287c0 1.105.895 1.999 2 1.999Z"
  })));
};
export default SvgOpenQuote;